import React, { useEffect, useState } from 'react';
import api from '../api/axiosConfig';
import './CompaniesPage.css';
import '../styles/rowActions.css';

export default function BunchSleeversPage() {
  const [sleevers, setSleevers] = useState([]);
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  const [newName, setNewName] = useState('');
  const [newFarmId, setNewFarmId] = useState('');
  const [creating, setCreating] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editFarmId, setEditFarmId] = useState('');
  const [savingId, setSavingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const load = () => {
    setLoading(true);
    return Promise.all([api.get('bunch-sleevers/'), api.get('farms/')])
      .then(([sleeversRes, farmsRes]) => {
        setSleevers(sleeversRes.data);
        setFarms(farmsRes.data);
        if (!newFarmId && farmsRes.data.length > 0) {
          setNewFarmId(String(farmsRes.data[0].id));
        }
      })
      .catch(() => setStatus({ type: 'error', text: 'No se pudieron cargar los enfundadores.' }))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newName.trim() || !newFarmId) return;
    setCreating(true);
    setStatus(null);
    try {
      const r = await api.post('bunch-sleevers/', { name: newName.trim(), farm: Number(newFarmId) });
      setSleevers((ss) => [...ss, r.data].sort((a, b) => a.name.localeCompare(b.name)));
      setNewName('');
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudo crear el enfundador.' });
    } finally {
      setCreating(false);
    }
  };

  const startEdit = (s) => {
    setEditingId(s.id);
    setEditName(s.name);
    setEditFarmId(String(s.farm));
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
    setEditFarmId('');
  };

  const handleSaveEdit = async (id) => {
    if (!editName.trim() || !editFarmId) return;
    setSavingId(id);
    setStatus(null);
    try {
      const r = await api.patch(`bunch-sleevers/${id}/`, { name: editName.trim(), farm: Number(editFarmId) });
      setSleevers((ss) => ss.map((s) => (s.id === id ? r.data : s)));
      cancelEdit();
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudieron guardar los cambios.' });
    } finally {
      setSavingId(null);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este enfundador?')) return;
    setDeletingId(id);
    setStatus(null);
    try {
      await api.delete(`bunch-sleevers/${id}/`);
      setSleevers((ss) => ss.filter((s) => s.id !== id));
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudo eliminar el enfundador.' });
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="companies-root">
      <h1 className="companies-title">🍌 Enfundadores</h1>

      <form className="companies-add-form" onSubmit={handleCreate}>
        <input
          className="companies-add-input"
          placeholder="Nombre del nuevo enfundador"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
        <select
          className="companies-add-input"
          value={newFarmId}
          onChange={(e) => setNewFarmId(e.target.value)}
        >
          {farms.length === 0 && <option value="">Aún no hay fincas</option>}
          {farms.map((f) => (
            <option key={f.id} value={f.id}>{f.name} ({f.company_name})</option>
          ))}
        </select>
        <button className="companies-add-btn" type="submit" disabled={creating || !newName.trim() || !newFarmId}>
          {creating ? 'Agregando…' : '+ Agregar enfundador'}
        </button>
      </form>

      {status && <div className={`companies-status companies-status-${status.type}`}>{status.text}</div>}

      <div className="companies-card">
        {loading ? (
          <div className="companies-empty">Cargando…</div>
        ) : sleevers.length === 0 ? (
          <div className="companies-empty">Aún no hay enfundadores.</div>
        ) : (
          <table className="companies-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Finca</th>
                <th>Creado por</th>
                <th>Creado</th>
                <th>Editado por</th>
                <th>Modificado</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sleevers.map((s) => (
                <tr key={s.id}>
                  <td>
                    {editingId === s.id ? (
                      <input
                        className="companies-edit-input"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        autoFocus
                      />
                    ) : (
                      s.name
                    )}
                  </td>
                  <td>
                    {editingId === s.id ? (
                      <select
                        className="companies-edit-input"
                        value={editFarmId}
                        onChange={(e) => setEditFarmId(e.target.value)}
                      >
                        {farms.map((f) => (
                          <option key={f.id} value={f.id}>{f.name} ({f.company_name})</option>
                        ))}
                      </select>
                    ) : (
                      `${s.farm_name} (${s.company_name})`
                    )}
                  </td>
                  <td>{s.created_by_username || '—'}</td>
                  <td>{new Date(s.created).toLocaleDateString()}</td>
                  <td>{s.last_edited_by_username || '—'}</td>
                  <td>{new Date(s.modified).toLocaleDateString()}</td>
                  <td>
                    <div className="row-actions">
                      {editingId === s.id ? (
                        <>
                          <button
                            className="row-icon-btn"
                            onClick={() => handleSaveEdit(s.id)}
                            disabled={savingId === s.id}
                            title="Guardar"
                            aria-label="Guardar"
                          >
                            {savingId === s.id ? '…' : '💾'}
                          </button>
                          <button className="row-icon-btn" onClick={cancelEdit} title="Cancelar" aria-label="Cancelar">✖️</button>
                        </>
                      ) : (
                        <>
                          <button className="row-icon-btn" onClick={() => startEdit(s)} title="Editar" aria-label="Editar">✏️</button>
                          <button
                            className="row-icon-btn"
                            onClick={() => handleDelete(s.id)}
                            disabled={deletingId === s.id}
                            title="Eliminar"
                            aria-label="Eliminar"
                          >
                            {deletingId === s.id ? '…' : '🗑️'}
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
